export default __webpack_public_path__ + "static/bankenes-logo-39b4eeb8ca3556d9c83a9cdf9e6d294a.png";